import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';

const TermsOfUse = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <header className="privacy-header">
          <Link className="privacy-back" to="/">
            <span aria-hidden="true">&larr;</span>
            Voltar para a landing
          </Link>
          <h1 className="privacy-title">TERMOS DE USO — FOODSTATION</h1>
          <p className="privacy-updated">Última atualização: 05/01/2025</p>
        </header>

        <main className="privacy-card">
          <section className="privacy-section">
            <h2>1. Identificação das Partes</h2>
            <h3>Controladora e Responsável pela Plataforma</h3>
            <p>
              GOURMEX TECNOLOGIA E MARKETING LTDA, pessoa jurídica de direito privado, inscrita no
              CNPJ sob nº 51.555.314/0001-91, com sede na Rua Dra. Rita Lobato, nº 194, Apto 202,
              Andar 2, Bairro Praia de Belas, Porto Alegre/RS, CEP 90110-040, doravante denominada
              “GOURMEX”.
            </p>
            <h3>Plataforma</h3>
            <p>
              FoodStation é uma plataforma tecnológica pertencente ao Grupo Gourmex, operada e
              mantida pela GOURMEX, não possuindo personalidade jurídica própria.
            </p>
            <h3>Usuário / Contratante</h3>
            <p>
              Pessoa física ou jurídica que realiza cadastro e utiliza a Plataforma FoodStation,
              doravante denominada “Usuário” ou “Cliente”.
            </p>
          </section>

          <hr className="privacy-divider" />

          <section className="privacy-section">
            <h2>2. Definições</h2>
            <ul className="privacy-list">
              <li>2.1. Plataforma: Ecossistema digital FoodStation, acessível via web.</li>
              <li>2.2. Soluções: Conjunto de módulos e funcionalidades disponibilizadas pela Plataforma.</li>
              <li>2.3. Conta: Cadastro individual do Usuário.</li>
              <li>2.4. Plano: Modalidade de assinatura contratada.</li>
              <li>2.5. Dados do Cliente: Informações inseridas pelo Usuário na Plataforma.</li>
              <li>2.6. Dados Pessoais: Dados conforme definição da Lei nº 13.709/2018 (LGPD).</li>
              <li>2.7. IA: Funcionalidades de inteligência artificial utilizadas para automação, sugestões e análises.</li>
            </ul>
          </section>

          <hr className="privacy-divider" />

          <section className="privacy-section">
            <h2>3. Objeto</h2>
            <p>
              A GOURMEX concede ao Usuário uma licença de uso não exclusiva, não transferível,
              revogável e limitada, para acesso e utilização da Plataforma FoodStation, conforme o
              Plano contratado, exclusivamente para fins internos da operação do restaurante.
            </p>
          </section>

          <hr className="privacy-divider" />

          <section className="privacy-section">
            <h2>4. Aceite Eletrônico</h2>
            <p>O aceite destes Termos ocorre mediante:</p>
            <ul className="privacy-list">
              <li>a) Cadastro na Plataforma;</li>
              <li>b) Marcação de checkbox de concordância;</li>
              <li>c) Confirmação de pagamento;</li>
              <li>d) Primeiro acesso à Plataforma.</li>
            </ul>
            <p>O aceite eletrônico equivale juridicamente à assinatura, nos termos da legislação vigente.</p>
          </section>

          <hr className="privacy-divider" />

          <section className="privacy-section">
            <h2>5. Planos, Cobrança e Cancelamento</h2>
            <ul className="privacy-list">
              <li>5.1. A Plataforma opera por modelo de assinatura, com renovação automática.</li>
              <li>5.2. O Usuário pode cancelar a qualquer momento, mantendo acesso até o final do período pago.</li>
              <li>5.3. Não há reembolso de valores pagos, salvo obrigação legal ou cobrança indevida.</li>
              <li>5.4. A GOURMEX poderá revisar valores mediante aviso prévio mínimo de 30 dias.</li>
            </ul>
          </section>

          <hr className="privacy-divider" />

          <section className="privacy-section">
            <h2>6. Uso da Plataforma e Inteligência Artificial</h2>
            <ul className="privacy-list">
              <li>6.1. A FoodStation fornece ferramentas de apoio à operação, não garantindo resultados financeiros ou operacionais.</li>
              <li>6.2. As funcionalidades de IA são auxiliares e não substituem análise humana.</li>
              <li>6.3. O Usuário é responsável por revisar conteúdos, mensagens e decisões geradas com apoio da IA.</li>
            </ul>
            <p>
              A GOURMEX não se responsabiliza por bloqueios, penalidades, suspensões ou sanções
              aplicadas por terceiros, incluindo provedores de mensagens, plataformas de comunicação
              ou redes sociais.
            </p>
          </section>

          <hr className="privacy-divider" />

          <section className="privacy-section">
            <h2>7. Obrigações do Usuário</h2>
            <p>O Usuário compromete-se a:</p>
            <ul className="privacy-list">
              <li>a) Utilizar a Plataforma de forma lícita;</li>
              <li>b) Garantir base legal para contato com clientes finais;</li>
              <li>c) Não praticar spam ou comunicações indevidas;</li>
              <li>d) Manter confidencialidade de suas credenciais;</li>
              <li>e) Ser responsável pelos dados e conteúdos inseridos.</li>
            </ul>
          </section>

          <hr className="privacy-divider" />

          <section className="privacy-section">
            <h2>8. Propriedade Intelectual</h2>
            <ul className="privacy-list">
              <li>8.1. A Plataforma FoodStation, seu código, design, marcas e tecnologia são de propriedade exclusiva da GOURMEX.</li>
              <li>8.2. Os dados e conteúdos inseridos pelo Usuário permanecem sob sua titularidade.</li>
              <li>8.3. A GOURMEX não utiliza dados do Cliente para treinar modelos de IA de terceiros, salvo consentimento expresso.</li>
            </ul>
          </section>

          <hr className="privacy-divider" />

          <section className="privacy-section">
            <h2>9. Limitação de Responsabilidade</h2>
            <p>
              A responsabilidade máxima da GOURMEX fica limitada ao valor total pago pelo Usuário
              nos últimos 12 (doze) meses.
            </p>
            <p>
              Em nenhuma hipótese haverá responsabilidade por danos indiretos, lucros cessantes,
              perda de dados, decisões automatizadas ou falhas de terceiros.
            </p>
          </section>

          <hr className="privacy-divider" />

          <section className="privacy-section">
            <h2>10. Alterações dos Termos</h2>
            <p>
              A GOURMEX poderá alterar estes Termos a qualquer momento, mediante publicação da
              versão atualizada. A continuidade do uso da Plataforma implica aceitação das
              alterações.
            </p>
          </section>

          <hr className="privacy-divider" />

          <section className="privacy-section">
            <h2>11. Lei Aplicável e Foro</h2>
            <p>Aplica-se a legislação brasileira.</p>
            <p>Fica eleito o foro da comarca de Porto Alegre/RS, ressalvados os direitos do consumidor.</p>
          </section>
        </main>
      </div>
    </div>
  );
};

export default TermsOfUse;
